/**
 * @generated SignedSource<<7333e707d2161a8b1aa1f22f627e1650>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue">;
  readonly " $fragmentType": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue";
};
export type ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue$key = {
  readonly " $data"?: ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "a82d3697e92fea96f21c1bc4281c03e5";

export default node;
